export default "data:application/font-woff;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZWVjY2Y0ZjY2MDAyYzZmMmJhMjRkM2QyMmYyNDM0YzIud29mZiI7"